/**
 * API 服务统一导出
 * 按功能模块组织，方便统一管理和使用
 */

// 统一导出所有 API（兼容旧代码） - import 语句必须在最前面
import * as authApi from './authApi';
import * as channelApi from './channelApi';
import * as detailApi from './detailApi';
import * as filterApi from './filterPageApi';
import * as historyApi from './historyApi';
import * as homeApi from './homeApi';
import * as liveApi from './liveApi';
import * as logApi from './logApi';
import * as searchApi from './searchApi';
import * as userApi from './userApi';
import * as vipApi from './vipApi';

// 基础 API 工具 - 必须先导出
export * from './api';
export * from '../utils/apiUtils';
export * from './apiPaths';

// 功能模块 API - 按字母顺序导出
export * from './authApi';
export * from './channelApi';
export * from './detailApi';
export * from './filterPageApi';
export * from './historyApi';
export * from './homeApi';
export * from './liveApi';
export * from './logApi';
export * from './searchApi';
export * from './userApi';
export * from './vipApi';

// 默认导出
export default {
  ...authApi,
  ...channelApi,
  ...detailApi,
  ...filterApi,
  ...historyApi,
  ...homeApi,
  ...liveApi,
  ...logApi,
  ...searchApi,
  ...userApi,
  ...vipApi,
};
